import posthog from 'posthog-js';
import CONSTANTS from 'shared/constants';

// Classify the current pathname so events can be filtered downstream in
// PostHog dashboards without needing to reason about raw pathnames each time.
// Anonymous email/preview flows are the biggest DAU inflator (CIN-6355), so
// we tag them here and skip PostHog entirely on /unsubscribe (email
// recipients never log in — full tracking creates permanent ghost persons)
// and on /customer-drawer when it's an iframe embed on an external site
// (parent tool is already tracking the same user, so init here doubles
// sessions/events). Direct hits on /customer-drawer on our own site still
// track normally.
const pathname = typeof window !== 'undefined' ? window.location.pathname : '';
const isInIframe = (() => {
  if (typeof window === 'undefined') return false;
  try {
    return window.self !== window.top;
  } catch {
    // Cross-origin access to window.top throws — that itself proves we're
    // embedded on a different-origin parent (i.e., an external site).
    return true;
  }
})();
const routeClassifiers = [{
  prefix: '/unsubscribe/',
  routeClass: 'unsubscribe',
  isPublic: true,
  skipInit: true
}, {
  prefix: '/auth/reset-password/',
  routeClass: 'reset-password',
  isPublic: true,
  skipInit: false
}, {
  prefix: '/preview-template/',
  routeClass: 'preview-template',
  isPublic: true,
  skipInit: false
}, {
  prefix: '/sign-in',
  routeClass: 'sign-in',
  isPublic: true,
  skipInit: false
}, {
  prefix: '/sign-up',
  routeClass: 'sign-up',
  isPublic: true,
  skipInit: false
}, {
  prefix: '/mfa',
  routeClass: 'mfa',
  isPublic: true,
  skipInit: false
}, {
  prefix: '/support',
  routeClass: 'support',
  isPublic: true,
  skipInit: false
}, {
  prefix: '/customer-drawer',
  routeClass: 'customer-drawer',
  isPublic: false,
  skipInit: isInIframe
}];
const match = routeClassifiers.find(r => pathname.startsWith(r.prefix));
const routeClass = match?.routeClass ?? 'app';
const isPublicRoute = match?.isPublic ?? false;
const skipInit = match?.skipInit ?? false;
if (!skipInit && CONSTANTS.ENV !== 'LOCAL') {
  posthog.init(POSTHOG_API_KEY, {
    api_host: POSTHOG_HOST,
    enableExceptionAutocapture: true
  });

  // Super-properties: attached to every subsequent event automatically. Enables
  // dashboards to filter to "real logged-in app users" (product_area = cinch_app
  // AND is_public_route = false AND is_internal_user = false — the last set on
  // identify in user-state-context).
  posthog.register({
    product_area: 'cinch_app',
    route_class: routeClass,
    is_public_route: isPublicRoute
  });
}
export default posthog;